<ng-container>
  <img src="//vkplaycloud.mrgcdn.ru/img/playkeynet/new/catalog/tooltip/demo_tooltip_close_2.png"
       class="tip-close"
       (click)="closeTip($event)" />
  <div class="tip-text"
       (click)="clickTip($event);">
    <ng-content></ng-content>
  </div>
</ng-container>
